export default "__VITE_ASSET__NZ$DtUj2__"